class INTENT.widgets.GroupEsimate

  @ATTR_NAME: "data-widget-groupestimate"

  @ATTR_MATCH_BUDGET: "data-match-budget"
  @ATTR_WARNING: "data-warning"
  @ATTR_GROUP_LIMIT: "data-group-limit"

  constructor: (@el) ->
    @s = @.constructor

    @groupMatchBudget = @el.find "[#{@s.ATTR_MATCH_BUDGET}]"
    @groupWarning = @el.find "[#{@s.ATTR_WARNING}]"

    @groupLimitField = @el.find "[#{@s.ATTR_GROUP_LIMIT}]"
    @groupLimitField.on 'keyup', (e) =>
      current = $ e.currentTarget
      match_budget = parseFloat @groupMatchBudget.val()
      new_budget_limit = parseFloat current.val()
      if isNaN(new_budget_limit) || new_budget_limit == undefined  || new_budget_limit == null
        new_budget_limit = 0

      if match_budget > new_budget_limit
        current.parents('.form-group').addClass('has-warning')
        @groupWarning.html INTENT.templates.CrudCampaign.get_text_container(__('campaign.group.warning'), 'warning')
      else
        current.parents('.form-group').removeClass('has-warning')
        @groupWarning.html ''